import React, { useState, useEffect, useContext } from "react";
import AccountAddBody from "../components/DataList/AccountAddBody";
import AccountAddTitle from "../components/DataList/AccountAddTitle";
import styled from "styled-components";
import { AuthContext } from "../contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import apiClient from "../libraries/ApiClient";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 95%;
  max-height: calc(100% - 50px);
`;

function AccountAdd({ lineUserId }) {
  const navigate = useNavigate();
  const { myAuth } = useContext(AuthContext);
  const isAdmin = myAuth.IsAdmin;
  const permission = myAuth.AccountPermission;
  const [sendAccountData, setSendAccountData] = useState(null);
  const [token, setToken] = useState("");

  useEffect(() => {
    const token = JSON.parse(localStorage.getItem("auth"))?.Token;
    setToken(token);
    // if (!isAdmin) {
    //   alert("您無此權限，為您轉到轉診清單頁");
    //   navigate("/ReferralDataList");
    // }
    if (permission == 3 || permission == 4) {
      alert("您無此權限，為您轉到轉診清單頁");
      navigate("/ReferralDataList");
    }
    const time = dayjs(new Date()).format("YYYY/MM/DD HH:mm:ss");
    const version = import.meta.env.VITE_VERSION;
    const accountRowId = JSON.parse(localStorage.getItem("auth"))?.AccountRowId;

    if (token === undefined) {
      navigate("/Login");
    }
    apiClient.logOfActionEnterPage(location.pathname, "EnterPage", {
      token,
      lineUserId,
      accountRowId,
      time,
      version,
    });
  }, []);

  return (
    <Container>
      <AccountAddTitle Mode="Add" sendAccountData={sendAccountData} />
      <AccountAddBody Mode="Add" setSendAccountData={setSendAccountData} />
    </Container>
  );
}

export default AccountAdd;
